/**
 * Страница авторизации (вход в систему)
 * 
 * Пользователь вводит логин и пароль
 * Если правильно — сохраняем токен и переходим на главную страницу
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { APP_NAME } from '../hooks/useDocumentTitle';
import '../styles/LoginPage.css';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await loginUser({ username, password });
      await login(response.user, response.access_token, response.refresh_token);
      navigate('/');
    } catch (err) {
      setError('❌ Ошибка: неверный логин или пароль');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <img
        className="login-page-logo"
        src="/logo-mark.png"
        alt="УНИВЕРСТРОЙ — Инженерные системы"
      />
      <h1 className="login-system-name">{APP_NAME}</h1>
      <div className="login-box">
        <h2 className="login-form-title">Вход в систему</h2>
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">👤 Логин:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Введите логин"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">🔒 Пароль:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Введите пароль"
              disabled={isLoading}
            />
          </div>

          <button type="submit" disabled={isLoading} className="submit-button">
            {isLoading ? '⏳ Загрузка...' : '➤ Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
